/** Pixel cabin used as the app brand mark. Walls + roof inherit `currentColor`
 *  from the surrounding text so the silhouette re-colours with the theme;
 *  windows and door are dark "cut-outs" styled via the `.cabin__glow` class
 *  so they always contrast with the walls regardless of theme. */

type Props = { size?: number; className?: string };

export function Cabin({ size = 26, className }: Props) {
  // Drawn on an 11×11 grid — each <rect> is a block of solid pixels.
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 12 11"
      shapeRendering="crispEdges"
      className={`pixel-cabin ${className ?? ''}`.trim()}
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* Roof — stepped triangle. Grid is 12 wide (even) so a 2-wide peak
          and 2-wide door both centre on the cols 5/6 boundary. */}
      <rect x="5" y="0" width="2" height="1" fill="currentColor" />
      <rect x="4" y="1" width="4" height="1" fill="currentColor" />
      <rect x="3" y="2" width="6" height="1" fill="currentColor" />
      <rect x="2" y="3" width="8" height="1" fill="currentColor" />
      <rect x="1" y="4" width="10" height="1" fill="currentColor" />
      {/* Roof eave — wider than the body for that cottage silhouette */}
      <rect x="0" y="5" width="12" height="1" fill="currentColor" />
      {/* Body */}
      <rect x="1" y="6" width="10" height="5" fill="currentColor" />
      {/* Windows — 2×2 each, symmetric about the vertical centre */}
      <rect x="2" y="7" width="2" height="2" className="cabin__glow" />
      <rect x="8" y="7" width="2" height="2" className="cabin__glow" />
      {/* Door — 2×3, centred on cols 5/6 */}
      <rect x="5" y="8" width="2" height="3" className="cabin__glow" />
    </svg>
  );
}
